import { makeStyles } from 'tss-react/mui';

import { MESSAGE_INPUT_RADIUS_PX, PILL_RADIUS_PX } from '../../constants';

type StyleParams = {
  isM1Enabled: boolean;
};

/** Styles for the Sidekick chat compact input bar (wrapper, textarea, send control). */
const useStyles = makeStyles<StyleParams>()((theme, { isM1Enabled }) => ({
  wrapper: {
    display: 'flex',
    alignItems: isM1Enabled ? 'center' : 'flex-end',
    gap: isM1Enabled ? theme.new.spacing.small : 12,
    width: '100%',
    minHeight: 48,
    boxSizing: 'border-box',
    padding: isM1Enabled
      ? `9px 12px 9px ${theme.new.spacing.medium}`
      : `${theme.new.spacing.small} ${theme.new.spacing.medium}`,
    backgroundColor: theme.new.color.common.white,
    border: isM1Enabled ? `1px solid ${theme.new.color.brand[600]}` : 'none',
    borderRadius: isM1Enabled ? PILL_RADIUS_PX : MESSAGE_INPUT_RADIUS_PX,
    ...(isM1Enabled
      ? {
          '&:focus-within': {
            boxShadow: `0 0 0 2px ${theme.new.color.common.white}, 0 0 2px 2px ${theme.new.color.brand[500]}`,
          },
        }
      : {}),
  },
  brandIconSlot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 32,
    height: 32,
    padding: theme.new.spacing.small,
    borderRadius: theme.new.shape.borderRadius.small,
    color: theme.new.color.brand[600],
  },
  textareaRoot: {
    flex: 1,
    padding: 0,
    margin: 0,
    '& .MuiInputBase-input': {
      ...(isM1Enabled
        ? theme.typography.small_body_regular
        : theme.typography.body_regular),
      color: theme.new.color.textPrimary,
      padding: 0,
      overflowWrap: 'anywhere',
    },
  },
  sendButton: {
    flexShrink: 0,
    width: isM1Enabled ? 28 : 40,
    height: isM1Enabled ? 28 : 40,
    padding: 0,
    color: theme.new.color.common.white,
    backgroundColor: theme.new.color.brand[600],
    border: `1px solid ${theme.new.color.line.border}`,
    borderRadius: isM1Enabled
      ? PILL_RADIUS_PX
      : theme.new.shape.borderRadius.small,
    '&:hover': {
      backgroundColor: theme.new.color.brand[700],
    },
    '&:active': {
      backgroundColor: theme.new.color.brand[800],
    },
  },
}));

export default useStyles;
